import { useState } from "react";
import useAxios from "./useAxios";

export type TSet = {
  api?: string;
  params?: any;
  method?: "PATCH" | "POST";
  type?: "application/json" | "multipart/form-data";
  id?: any;
  onSuccess?: any;
  successMessage?: any;
};

const useSet = () => {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError]: any = useState(null);
  const [success, setSuccess] = useState(false);
  const [data, setData] = useState<any>();
  const { set } = useAxios();

  const uploadData = ({
    api,
    params,
    method,
    type,
    id,
    onSuccess,
    successMessage,
  }: TSet) => {
    setError(null);
    setSuccess(false);
    setSubmitting(true);

    // If params is a FormData instance, pass it through untouched.
    // Spreading FormData with { ...formData } produces an empty object {}
    // because FormData entries are not enumerable — this silently drops
    // all fields and causes the server to return validation errors.
    const resolvedParams =
      params instanceof FormData ? params : { ...params };

    set({
      api: id ? `${api}${id}/` : api,
      loader: setSubmitting,
      errorHandler: setError,
      successHandler: (res: any) => {
        setData(res);
        setSuccess(true);
        onSuccess && onSuccess(res);
      },
      methodName: method || (id ? "PATCH" : "POST"),
      params: resolvedParams,
      type,
      successMessage,
    });
  };

  const updateErrors = (err: any) => {
    setError(err ? { ...error, ...err } : null);
  };

  return {
    submitting,
    error,
    data,
    success,
    uploadData,
    updateErrors,
    setError,
    setSuccess,
  };
};

export default useSet;